import { Checkbox } from 'ui'
import { FieldValidationSignature } from '.'
import { usePDFStore } from '../../../stores/pdf.store'

export const FieldValidationRequired: FieldValidationSignature = ({
  field,
}) => {
  const updateField = usePDFStore((state) => state.updateField)

  return (
    <div className='flex items-center space-x-2'>
      <Checkbox
        onCheckedChange={(value) =>
          updateField(field.id, {
            is_required: Boolean(value),
          })
        }
        defaultChecked={field.is_required}
      />
      <label
        htmlFor='terms2'
        className='text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
      >
        Requerido
      </label>
    </div>
  )
}
